(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faf-catalogue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-faf-catalogue-reveal]').forEach((catalogue) => {
      if (catalogue.dataset.revealReady === 'true') return;
      catalogue.dataset.revealReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || !('IntersectionObserver' in window)) {
        catalogue.classList.add('is-visible');
        return;
      }
      catalogue.classList.add('faf-paths--motion-ready');
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        catalogue.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: 0.12 });
      observer.observe(catalogue);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-flight-desk"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-flight-desk-reveal]');
    if (!section || section.dataset.revealReady === 'true') return;
    section.dataset.revealReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }
    section.classList.add('faf-flight-desk--motion-ready');
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      section.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: .1 });
    observer.observe(section);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faf-zazzle-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliders = document.querySelectorAll('[data-faf-store-slider]');
    sliders.forEach((slider) => {
      if (slider.dataset.sliderReady === 'true') return;
      const track = slider.querySelector('[data-slider-track]');
      const slides = [...slider.querySelectorAll('[data-slider-slide]')];
      const dots = [...slider.querySelectorAll('[data-slider-dot]')];
      const previous = slider.querySelector('[data-slider-previous]');
      const next = slider.querySelector('[data-slider-next]');
      const number = slider.querySelector('[data-slider-number]');
      const name = slider.querySelector('[data-slider-name]');
      let activeIndex = 0;
      let timer;

      slider.classList.add('faf-store-slider--motion-ready');
      const reveal = () => slider.classList.add('is-visible');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            reveal();
            observer.disconnect();
          }
        }, { threshold: 0.16 });
        observer.observe(slider);
      } else {
        reveal();
      }

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${activeIndex * 100}%)`;
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false'));
        number.textContent = String(activeIndex + 1).padStart(2, '0');
        name.textContent = slides[activeIndex].dataset.storeName;
      };
      const stopAutoPlay = () => window.clearInterval(timer);
      const startAutoPlay = () => {
        stopAutoPlay();
        timer = window.setInterval(() => showSlide(activeIndex + 1), 8000);
      };
      previous.addEventListener('click', () => { showSlide(activeIndex - 1); startAutoPlay(); });
      next.addEventListener('click', () => { showSlide(activeIndex + 1); startAutoPlay(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.sliderDot)); startAutoPlay(); }));
      slider.addEventListener('mouseenter', stopAutoPlay);
      slider.addEventListener('mouseleave', startAutoPlay);
      slider.addEventListener('focusin', stopAutoPlay);
      slider.addEventListener('focusout', startAutoPlay);
      slider.dataset.sliderReady = 'true';
      showSlide(0);
      startAutoPlay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const emblemGrid = document.querySelector('[data-faf-emblem-products]');
  if (emblemGrid && emblemGrid.dataset.motionReady !== 'true') {
    emblemGrid.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      emblemGrid.classList.add('is-visible');
    } else {
      emblemGrid.classList.add('faf-emblem-products--motion-ready');
      const emblemObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          emblemObserver.unobserve(entry.target);
        });
      }, { threshold: .08 });
      emblemObserver.observe(emblemGrid);
    }
  }

  const categoryGrid = document.querySelector('[data-faf-category-products]');
  if (categoryGrid && categoryGrid.dataset.motionReady !== 'true') {
    categoryGrid.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      categoryGrid.classList.add('is-visible');
    } else {
      categoryGrid.classList.add('faf-category-products--motion-ready');
      const categoryObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          categoryObserver.unobserve(entry.target);
        });
      }, { threshold: .08 });
      categoryObserver.observe(categoryGrid);
    }
  }

  document.querySelectorAll('[data-faf-emblem-video]').forEach((panel) => {
    if (panel.dataset.videoReady === 'true') return;
    panel.dataset.videoReady = 'true';
    const poster = panel.querySelector('.faf-emblem-video__poster');
    const videoId = panel.dataset.videoId;
    if (!poster || !videoId) return;

    poster.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.className = 'faf-emblem-video__player';
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0`;
      iframe.title = poster.getAttribute('aria-label') || 'Fly As A Falcon collection film';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      poster.replaceWith(iframe);
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
(() => {
  const root = document.querySelector('.faf-catalogue');
  if (!root) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = (element, motionClass) => {
    if (!element || element.dataset.themeRevealReady === 'true') return;
    element.dataset.themeRevealReady = 'true';
    if (reducedMotion || !('IntersectionObserver' in window)) {
      element.classList.add('is-visible');
      return;
    }
    element.classList.add(motionClass);
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      element.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: .12 });
    observer.observe(element);
  };

  const hero = root.querySelector('.faf-cat-hero');
  if (hero && hero.dataset.homeLayout !== 'true') {
    hero.dataset.homeLayout = 'true';
    const code = hero.querySelector(':scope > .faf-code');
    const title = hero.querySelector(':scope > h2');
    const copy = hero.querySelector(':scope > p:not(.faf-code)');
    const rail = hero.querySelector(':scope > .faf-cat-rail');
    if (code && title && copy && rail) {
      const frame = document.createElement('div');
      frame.className = 'faf-cat-hero__frame';
      const topline = document.createElement('div');
      topline.className = 'faf-cat-hero__topline';
      const flightPath = document.createElement('p');
      flightPath.textContent = 'FLIGHT PATH / 00';
      topline.append(code, flightPath);
      const layout = document.createElement('div');
      layout.className = 'faf-cat-hero__layout';
      const copyPanel = document.createElement('div');
      copyPanel.className = 'faf-cat-hero__copy';
      title.id = 'faf-catalogue-hero-title';
      copyPanel.append(title, copy);
      const visual = document.createElement('div');
      visual.className = 'faf-cat-hero__visual';
      visual.innerHTML = '<div class="faf-cat-hero__badge"><span>TAKE</span><em>FLIGHT</em><small>CATALOGUE / 01-10</small></div>';
      const railLogoSpace = rail.querySelector(':scope > span:last-child');
      if (railLogoSpace) {
        railLogoSpace.replaceChildren();
        railLogoSpace.setAttribute('aria-hidden', 'true');
      }
      layout.append(copyPanel, visual);
      frame.append(topline, layout, rail);
      hero.replaceChildren(frame);
      const cornerLogo = document.createElement('a');
      cornerLogo.className = 'faf-cat-hero__corner-logo';
      cornerLogo.href = '/collections/fly-as-a-falcon-black-gold-collection';
      cornerLogo.setAttribute('aria-label', 'Shop the Fly As A Falcon Black & Gold collection');
      cornerLogo.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/1026/1741/6022/files/fly-as-a-falcon-black-gold-emblem.png?v=1792581010" alt="Fly As A Falcon Black & Gold collection emblem" width="900" height="900">';
      hero.append(cornerLogo);
      hero.setAttribute('aria-labelledby', title.id);
    }
  }

  let paths = root.querySelector('#faf-catalogue-collections');
  const originalPaths = root.querySelector('.faf-homegrid-section');
  const pathsTemplate = document.querySelector('#faf-catalogue-home-emblems-template');
  if (!paths && originalPaths && pathsTemplate) {
    paths = pathsTemplate.content.firstElementChild.cloneNode(true);
    originalPaths.replaceWith(paths);
  }

  const featuredSlider = root.querySelector('.faf-cat-slider');
  if (featuredSlider && featuredSlider.dataset.optionsReady !== 'true') {
    const options = [
      { number: '01', descriptor: 'AFTER DARK', name: 'COSMOS' },
      { number: '02', descriptor: 'REBIRTH', name: 'PHOENIX' },
      { number: '03', descriptor: 'SUN-FADED SPORT', name: 'GOLDEN HAZE' }
    ];
    const buttons = [...featuredSlider.querySelectorAll('[data-cat-dot]')];
    buttons.forEach((button, index) => {
      const option = options[index];
      if (!option) return;
      button.innerHTML = `<span class="faf-cat-slider__option-number">${option.number}</span><span class="faf-cat-slider__option-copy"><strong>${option.descriptor}</strong><small>${option.name}</small></span>`;
    });
    const syncSelection = () => buttons.forEach((button) => button.setAttribute('aria-current', button.classList.contains('is-active') ? 'true' : 'false'));
    syncSelection();
    const selectionObserver = new MutationObserver(syncSelection);
    buttons.forEach((button) => selectionObserver.observe(button, { attributes: true, attributeFilter: ['class'] }));
    featuredSlider.dataset.optionsReady = 'true';
  }

  reveal(hero, 'faf-cat-hero--motion-ready');
  reveal(root.querySelector('#faf-categories'), 'faf-category-grid--motion-ready');
  reveal(paths, 'faf-paths--motion-ready');
  reveal(featuredSlider, 'faf-cat-slider--motion-ready');
})();

  } catch(e) { console.error(e); }
})();
})();
